"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
const QuantitySelector = t0 => {
  const $ = _c(36);
  const {
    value,
    onChange,
    min: t1,
    max
  } = t0;
  const min = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] !== value) {
    t2 = value.toString();
    $[0] = value;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [inputValue, setInputValue] = useState(t2);
  let t3;
  if ($[2] !== min || $[3] !== onChange || $[4] !== value) {
    t3 = () => {
      const newValue = Math.max(min, value - 1);
      onChange(newValue);
      setInputValue(newValue.toString());
    };
    $[2] = min;
    $[3] = onChange;
    $[4] = value;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleDecrement = t3;
  let t4;
  if ($[6] !== max || $[7] !== onChange || $[8] !== value) {
    t4 = () => {
      const newValue_0 = max ? Math.min(max, value + 1) : value + 1;
      onChange(newValue_0);
      setInputValue(newValue_0.toString());
    };
    $[6] = max;
    $[7] = onChange;
    $[8] = value;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleIncrement = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = e => {
      const input = e.target.value;
      if (input === "" || /^\d+$/.test(input)) {
        setInputValue(input);
      }
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleInputChange = t5;
  let t6;
  if ($[11] !== inputValue || $[12] !== max || $[13] !== min || $[14] !== onChange || $[15] !== value) {
    t6 = () => {
      const numValue = parseInt(inputValue, 10);
      if (isNaN(numValue) || numValue < min) {
        setInputValue(value.toString());
      } else {
        const clampedValue = max ? Math.min(max, Math.max(min, numValue)) : Math.max(min, numValue);
        onChange(clampedValue);
        setInputValue(clampedValue.toString());
      }
    };
    $[11] = inputValue;
    $[12] = max;
    $[13] = min;
    $[14] = onChange;
    $[15] = value;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const handleInputBlur = t6;
  let t7;
  let t8;
  if ($[17] !== value) {
    t7 = () => {
      setInputValue(value.toString());
    };
    t8 = [value];
    $[17] = value;
    $[18] = t7;
    $[19] = t8;
  } else {
    t7 = $[18];
    t8 = $[19];
  }
  React.useEffect(t7, t8);
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="text-[#004BEE] text-[18px] font-medium leading-none select-none">-</span>;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== handleDecrement) {
    t10 = <button onClick={handleDecrement} className="flex items-center justify-center w-8 h-8 bg-white cursor-pointer border-r border-[#AEB7F9] hover:bg-[#f5f5f5] active:bg-[#e8e8e8]">{t9}</button>;
    $[21] = handleDecrement;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== handleInputBlur || $[24] !== inputValue || $[25] !== min) {
    t11 = <div className="flex items-center justify-center min-w-[40px] h-[36px] bg-[#E6E9FD] border-r border-[#AEB7F9]"><input type="text" inputMode="numeric" value={inputValue} onChange={handleInputChange} onBlur={handleInputBlur} className="font-manrope font-medium text-[16px] text-[#004BEE] bg-transparent border-none outline-none w-[34px] text-center" min={min} /></div>;
    $[23] = handleInputBlur;
    $[24] = inputValue;
    $[25] = min;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const t12 = max !== undefined && value >= max;
  const t13 = `flex items-center justify-center w-8 h-8 bg-white cursor-pointer hover:bg-[#f5f5f5] active:bg-[#e8e8e8] ${max !== undefined && value >= max ? "opacity-50 cursor-not-allowed" : ""}`;
  let t14;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="text-[#004BEE] text-[18px] font-medium leading-none select-none">+</span>;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== handleIncrement || $[29] !== t12 || $[30] !== t13) {
    t15 = <button onClick={handleIncrement} disabled={t12} className={t13}>{t14}</button>;
    $[28] = handleIncrement;
    $[29] = t12;
    $[30] = t13;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t10 || $[33] !== t11 || $[34] !== t15) {
    t16 = <div className="flex items-center border border-[#AEB7F9] rounded-[24px] overflow-hidden h-8 w-fit">{t10}{t11}{t15}</div>;
    $[32] = t10;
    $[33] = t11;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
};
export default QuantitySelector;